import styled, { css } from 'styled-components';

interface ITextAlign {
  textAlign?: string;
  margin?: string;
}

interface ISize {
  height?: string;
  width?: string;
}

const contentCss = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const ContentWrapper = styled.div`
  ${contentCss}
`;

export const CenteredContentWrapper = styled.div`
  ${contentCss};
  justify-content: center;
`;

export const CenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TopSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #eeeaea;
  margin-bottom: 2.5rem;
  padding-bottom: 2rem;
  width: 100%;
  ${Styles.mobile`
    flex-direction: column;
  `};
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 400px;
`;

export const FormInputs = styled.div`
  display: flex;
  flex-shrink: 0;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
`;

export const CardNumberContainer = styled.div`
  width: 250px;
  margin-bottom: 15px;
`;

export const PinContainer = styled.div`
  width: 100px;
  margin-bottom: 15px;
`;

export const PlacementHolder = styled.div<ISize>`
  height: ${p => p.height};
  width: ${p => p.width};
`;

export const TimCardContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  width: 250px;
  height: 250px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  margin: 10px 20px;
`;

export const HeadingText = styled.h4<ITextAlign>`
  color: #432726;
  font-size: 2rem;
  font-weight: bold;
  letter-spacing: -1.13px;
  line-height: 1.14;
  margin: ${p => p.margin || 0};
`;

export const NormalText = styled.p<ITextAlign>`
  color: #432726;
  font-size: 1rem;
  line-height: 1.56;
  font-family: ${Styles.fontFamily.base};
  text-align: ${p => p.textAlign || 'center'};
  margin: ${p => p.margin || 0};
`;

export const ErrorAnchor = styled.a`
  color: ${Styles.color.primary};
`;

export const ErrorText = styled(NormalText).attrs({
  role: 'alert',
})`
  color: ${Styles.color.primary};
  font-weight: ${Styles.fontWeight.heavy};
  margin-bottom: 1rem;
`;
